import { useState, useEffect } from 'react';

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const navLinks = [
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Projects', id: 'projects' },
    { label: 'Reviews', id: 'reviews' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0e1a]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" className="flex items-center shrink-0">
          <img
            src="https://clwizard.com/wp-content/uploads/2022/05/Blushot-Logo-®.png"
            alt="CLWizard Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-gray-300 hover:text-white font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:5617745120"
            className="text-white font-semibold text-sm tracking-wide hover:text-[#0055ff] transition-colors whitespace-nowrap flex items-center gap-2"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#0055ff]"></i>
            </span>
            (561) 774-5120
          </a>
          <button
            onClick={() => scrollTo('contact')}
            className="bg-[#0055ff] hover:bg-[#0044cc] text-white font-bold px-6 py-2.5 rounded-md transition-all duration-200 whitespace-nowrap text-sm uppercase tracking-wider cursor-pointer"
          >
            Get a Free Inspection
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0e1a]/98 border-t border-white/10 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-gray-300 hover:text-white font-medium text-sm text-left py-2 border-b border-white/5 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:5617745120"
            className="text-white font-semibold text-base flex items-center gap-2 py-2"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#0055ff]"></i>
            </span>
            (561) 774-5120
          </a>
          <button
            onClick={() => scrollTo('contact')}
            className="bg-[#0055ff] text-white font-bold px-6 py-3 rounded-md whitespace-nowrap text-sm uppercase tracking-wider w-full cursor-pointer"
          >
            Get a Free Inspection
          </button>
        </div>
      )}
    </nav>
  );
}
